export const TDI_CONNECT_ROLE_PREFIX = 'TDI_CONNECT_' as const;

export const baseUserRoles = [
  'ADMIN',
  'SUPPORT',
  'CAAS_ADMIN',
  'ACCOUNT_OWNER',
  'ACCOUNT_ASSISTANT',
  'TECHNICAL_LEAD',
  'DEVELOPER',
] as const;

export type BaseUserRole = (typeof baseUserRoles)[number];

// Every base role has a TDI_CONNECT_-prefixed variant carrying identical permissions,
// so callers only need to enumerate base roles once and get both forms for free.
export const withTdiConnectVariants = (roles: readonly string[]): string[] => [
  ...roles,
  ...roles.map(role => `${TDI_CONNECT_ROLE_PREFIX}${role}`),
];

export const availableUserRoles = withTdiConnectVariants(baseUserRoles);

const elevatedPrivilegeBaseRoles: BaseUserRole[] = ['ADMIN', 'SUPPORT', 'CAAS_ADMIN'];

export const elevatedPrivilegeRoles = withTdiConnectVariants(elevatedPrivilegeBaseRoles);

const config = {
  baseUserRoles,
  availableUserRoles,
  elevatedPrivilegeRoles,
  withTdiConnectVariants,
};

export default config;
